module.exports = __webpack_public_path__ + "assets/img/blogbook.e944c653.svg";